import decodeHtmlEntitiesRecursive from '@core/utils/helpers/decodeHtmlEntitiesRecursive'
import useFormattedDatesPeriod from '@core/utils/hooks/useFormattedDatesPeriod'
import clsx from 'clsx'
import React from 'react'
import type { ApplyV2TempWorkExperience } from '@core/app/types/applyV2Type'
import ApplyV2DataRow from '@core/components/ApplyDialogV2/ApplyV2DataRow'
import { useApplyV2Context } from '@core/utils/contexts/ApplyV2ModalContext/ApplyV2ModalContext'
import duration from 'dayjs/plugin/duration'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import './ApplyV2ReviewApplyExperience.scss'
import { useTranslation } from 'react-i18next'

dayjs.extend(duration)
dayjs.extend(customParseFormat)

const baseClass = 'ApplyV2ReviewApplyExperience'

interface Props {
    className?: string
    isShowExpandButton?: boolean
}

function ApplyV2ReviewApplyExperience({ className = '' }: Props) {
    const {
        postProfileData,
        postProfileError,
        isPostProfileLoading,
        isPostProfileSuccess,
        isSettingsLoading,
        isSettingsFetching,
    } = useApplyV2Context()
    const { t } = useTranslation()
    const data = postProfileData?.data?.workExperience || []
    const isEmpty = data.length === 0
    const noFields = postProfileData?.data?.noFields ?? []

    return (
        <div
            className={clsx(baseClass, className, {
                [`${baseClass}--isEmpty`]: isEmpty,
            })}
        >
            {noFields.includes('workExperience') ? (
                <div>{t('10302', "I don't have any work experience")}</div>
            ) : isEmpty ? (
                <div
                    className={clsx(baseClass, className, {
                        [`${baseClass}--isEmpty`]: isEmpty,
                    })}
                >
                    {t('10702', 'No work experience added')}
                </div>
            ) : (
                data.map((item) => <ApplyV2ReviewApplyExperienceItem key={item.uid || item.existingId} {...item} />)
            )}
        </div>
    )
}

function ApplyV2ReviewApplyExperienceItem({
    uid,
    existingId,
    title,
    companyName,
    location,
    fromDate,
    toDate,
    description,
    titleListId,
    current,
}: ApplyV2TempWorkExperience) {
    const { formatDateRange, formatDuration } = useFormattedDatesPeriod()

    const periodDate = formatDateRange(fromDate, toDate)

    const duration = fromDate || toDate ? formatDuration(fromDate, toDate) : ''

    return (
        <div className={`${baseClass}__item`}>
            <div className={`${baseClass}__item--name`}>{decodeHtmlEntitiesRecursive(companyName)}</div>
            <div className={`${baseClass}__item--position`}>
                {title && (
                    <span className={`${baseClass}__item--position-title`}>{decodeHtmlEntitiesRecursive(title)}</span>
                )}
            </div>
            {!!periodDate && (
                <ApplyV2DataRow fieldType={'date'} className={`${baseClass}__item--mobilePhone`}>
                    <span>{periodDate}</span> {duration && <span>({duration})</span>}
                </ApplyV2DataRow>
            )}
            {location && (
                <ApplyV2DataRow fieldType={'location'} className={`${baseClass}__item--email`}>
                    {decodeHtmlEntitiesRecursive(location)}
                </ApplyV2DataRow>
            )}
            {description && (
                <div className={`${baseClass}__item--description`}>{decodeHtmlEntitiesRecursive(description)}</div>
            )}
        </div>
    )
}

export default ApplyV2ReviewApplyExperience
